import axios from "axios";
import cookie from "react-cookies";
import {
  RIMS_COOKIE_STG_CONSTANTS,
} from "../constants";
import { useConfigStore } from "../store/config";
import { basicUrl } from ".";
import {getURLDomain} from "../common/utils";
import { getResolvedTenantId } from "../common/tenant";

const config = {
  baseURL: basicUrl,
};

const CDCHttpService = axios.create(config);

CDCHttpService.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    const token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    const tenantId = getResolvedTenantId(config.url);
    config.headers = {
      "Content-Type": "application/json;charset=utf-8",
      "X-Tenant-Id": tenantId,
      Authorization: `Bearer ${token}`,
      "Accept-Language": languageformat || "",
      "domain-name": getURLDomain(),
      "x-username": cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_NAME)
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

CDCHttpService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default CDCHttpService;
